import _ from "lodash";
import { generateId, isStringNotNull } from "../../../../../utils";
import { isCategoryOptionProductType } from "../../../../../utils/order";
import {
  getOptionAssociatedProduct,
  getStockRemaining,
  getCurrentNbOption,
  isProductDisabled,
} from "../../../../../utils/product";
import {
  NOT_FOUND_INDEX,
  ITEM_KEY_COUNTER_SEPARATOR,
  ITEM_KEY_CATEGORY_SEPARATOR,
  CATEGORY_SEPARATOR,
  PRODUCT_WITHOUT_REF,
  STOCK_ALMOST_EMPTY,
} from "../../../../../constants";
import store from "../../../../../redux/store";
import { STICKY_HEADER_HEIGHT } from "./ProductDetailModal.styles";
import { getBngmOptionValue } from "../../../../../utils/bngmOffer";
export const generateCounterOptionKey = (categoryKey, optionKey) =>
  `${categoryKey}${optionKey}`;

export const initializeNewProduct = (
  categoriesProps,
  categoriesToAdd,
  state,
  setState,
  pendingOrder,
  stockRemaining,
  productOffer,
  product,
  sectionKey,
) => {
  const prepared = prepareCategories(categoriesProps, categoriesToAdd, state);
  let { categories, linkBetweenOptionsAndSubOptions } = prepared;
  const initialSortedCategories = prepared.sortedCategories;
  const ensuredSortedCategories = ensureProductOfferCategory({
    productOffer,
    product,
    sectionKey,
    categoriesProps,
    sortedCategories: initialSortedCategories,
  });
  let sortedCategories = ensuredSortedCategories || initialSortedCategories;
  let updatedProductItems = _.cloneDeep(state.productItems);
  const categoriesArray = Object.values(sortedCategories);
  _.forEach(categoriesArray, (category: any, index: number) => {
    const uniqueOption = isUniqueOption(category);
    if (uniqueOption && category.items) {
      const itemKeys = Object.keys(category.items);
      if (itemKeys.length === 1) {
        const selectedItem = category.items[itemKeys[0]];
        if (
          !optionHasNotEnoughStock(
            state.productItems,
            pendingOrder,
            selectedItem,
            1,
          )
        ) {
          if (category.optionFree) {
            const optionsArray = _.values(
              updatedProductItems[selectedItem.key]?.options ?? {},
            );
            const freeItems = optionsArray
              .slice(0, category.optionFree)
              .map((elm) => elm.key);
            const isFreeItem = category.multiple
              ? freeItems.includes(selectedItem.key) &&
                freeItems.length < category.optionFree
              : freeItems.includes(selectedItem.key);

            selectedItem.isFree =
              isFreeItem || _.size(optionsArray) < category.optionFree;
          }
          const item = {
            ...selectedItem,
            categoryKey: category.key,
            label: selectedItem.name,
            value: getBngmOptionValue(selectedItem, productOffer),
            nb: selectedItem.nb ?? 1,
          };
          const itemRecursiveKey = generateItemRecursiveKey(item);
          ({
            updatedProductItems,
            categories,
            sortedCategories,
            linkBetweenOptionsAndSubOptions,
          } = updateSubCategories(
            updatedProductItems,
            categories,
            sortedCategories,
            linkBetweenOptionsAndSubOptions,
            category.key,
            item,
            itemRecursiveKey,
            false,
          ));
          updatedProductItems.push(
            generateProductItem(
              category,
              index,
              updatedProductItems,
              itemRecursiveKey,
              item,
            ),
          );
        }
      }
    }
  });
  const stockUpdate = {
    nbProduct: Math.max(state.nbProduct + 1, 0),
  };

  setState({
    productItems: sortProductItemsAccordingToSortedCategories(
      updatedProductItems,
      sortedCategories,
    ),
    categories,
    sortedCategories,
    linkBetweenOptionsAndSubOptions,
    ...(stockRemaining <= 0 ? {} : stockUpdate),
  });
};
export const updateSubCategories = (
  productItems,
  updatedCategories,
  updatedSortedCategories,
  updatedLinkBetweenOptionsAndSubOptions,
  categoryKey,
  newItem,
  itemRecursiveKey,
  isMultiple = true,
) => {
  const productItemToRemove = _.find(
    productItems,
    (productItem) => productItem?.categoryKey === categoryKey,
  );
  if (newItem?.subcategories) {
    const categoriesToAdd = newItem.subcategories.split(CATEGORY_SEPARATOR);
    const categoriesUpdateResult = addCategories(
      updatedCategories,
      updatedSortedCategories,
      updatedLinkBetweenOptionsAndSubOptions,
      categoriesToAdd,
      categoryKey,
      newItem?.label,
      itemRecursiveKey || newItem?.key,
      isMultiple,
    );
    ({
      categories: updatedCategories,
      sortedCategories: updatedSortedCategories,
      linkBetweenOptionsAndSubOptions: updatedLinkBetweenOptionsAndSubOptions,
    } = categoriesUpdateResult);
  }
  return {
    updatedProductItems: sortProductItemsAccordingToSortedCategories(
      productItems,
      updatedSortedCategories,
      categoryKey,
    ),
    productItemToRemove,
    categories: updatedCategories,
    sortedCategories: updatedSortedCategories,
    linkBetweenOptionsAndSubOptions: updatedLinkBetweenOptionsAndSubOptions,
  };
};

export const generateProductItem = (
  category,
  index,
  productItems,
  itemRecursiveKey,
  item,
) => {
  const { sections } = store.getState().shopReducer;
  const itemId = generateId();
  const addedItem = {
    ...item,
    itemRecursiveKey,
    price: item.isFree ? 0 : item.price,
  };

  const findSectionByProductKey = (productKey) =>
    _.find(sections, (section) => {
      const product = section.products?.[productKey];
      return product?.key === productKey && !product?.disabled;
    });
  const resolveSection = (item) =>
    item.sectionKey &&
    _.find(sections, (section) => item.sectionKey === section.key);

  const findSectionByRef = (ref) =>
    _.find(sections, (section) =>
      _.some(
        section.products || {},
        (product) =>
          !product?.disabled &&
          (product?.ref === ref || product?.ref === PRODUCT_WITHOUT_REF),
      ),
    );

  if (item.productKey) {
    const section =
      resolveSection(item) || findSectionByProductKey(item.productKey);
    if (section) {
      addedItem.sectionKey = section.key;
    } else {
      addedItem.productKey = null;
    }
  } else if (isCategoryOptionProductType(item) && item.ref) {
    const section = resolveSection(item.ref) || findSectionByRef(item.ref);
    if (section) {
      addedItem.sectionKey = section.key;
    }
  }
  if (category?.isBngmSlot && !addedItem.productKey) {
    for (const sec of sections || []) {
      const matchedEntry = _.find(
        Object.entries(sec?.products || {}) as [
          string,
          { disabled?: boolean; ref?: string },
        ][],
        ([, menuProduct]) =>
          menuProduct &&
          !menuProduct.disabled &&
          (menuProduct.ref === item.ref ||
            menuProduct.ref === PRODUCT_WITHOUT_REF),
      );
      if (matchedEntry) {
        const [matchedProductKey] = matchedEntry;
        addedItem.productKey = matchedProductKey;
        if (!addedItem.sectionKey) {
          addedItem.sectionKey = sec.key;
        }
        break;
      }
    }
  }
  const options = isUniqueOption(category)
    ? { [itemId]: addedItem }
    : { ...{ ...(productItems?.[index]?.options ?? {}) }, [itemId]: addedItem };

  return {
    categoryKey: category?.key ?? item.categoryKey,
    categoryId: category.id,
    categoryPosition: index,
    ref: category.ref,
    categoryName: category.name,
    categoryMultiple: category.multiple,
    isMarketingCampaignProductOffered:
      category.isMarketingCampaignProductOffered ?? undefined,
    options,
  };
};
export const sortProductItemsAccordingToSortedCategories = (
  productItems,
  sortedCategories,
  ignoredCategoryKey = null,
) =>
  sortedCategories?.map((category, index) => {
    if (ignoredCategoryKey && ignoredCategoryKey === category?.key) {
      return null;
    }
    const matchingProduct = _.find(
      productItems,
      (product) =>
        product?.categoryKey && product.categoryKey === category?.key,
    );
    return matchingProduct
      ? {
          ...matchingProduct,
          categoryPosition: index,
          categoryName: matchingProduct.categoryName.split(" - ").pop(),
        }
      : null;
  }) || [];

const prepareCategories = (categories, categoriesToAdd, state) => {
  const { linkBetweenOptionsAndSubOptions, itemsCounter } = state;
  const newCategories = _.cloneDeep(categories);
  const newSortedCategories = [];
  return {
    itemsCounter,
    ...addCategories(
      newCategories,
      newSortedCategories,
      linkBetweenOptionsAndSubOptions,
      categoriesToAdd,
      null,
      null,
      null,
      null,
    ),
  };
};
export const ensureProductOfferCategory = ({
  productOffer,
  product,
  sectionKey,
  categoriesProps,
  sortedCategories,
}) => {
  if (!productOffer || !product || !categoriesProps) return;

  const productOfferCategory = `${productOffer?.key}__${sectionKey}__${product.key}`;
  const newCate = _.cloneDeep(
    categoriesProps[`${productOffer?.key}__${sectionKey}__${product.key}`],
  );

  if (!newCate) return;

  const ensuredSortedCategories = _.cloneDeep(sortedCategories || []);
  const alreadyExists = _.some(ensuredSortedCategories, {
    id: productOfferCategory,
  });

  if (!alreadyExists) {
    const newIndex = ensuredSortedCategories.length;
    ensuredSortedCategories.push({
      ...newCate,
      categoryKey: `${newCate.key}@${newIndex}`,
      categoryId: `${newCate.id}@${newIndex}`,
    });
    return ensuredSortedCategories;
  }
};

export const addCategories = (
  categories,
  sortedCategories,
  linkBetweenOptionsAndSubOptions,
  categoriesToAdd,
  categoryKey,
  parentItemLabel,
  parentItemRecursiveKey,
  isMultiple,
) => {
  const newSubcategories = [];
  const categoryToAddPosition = categoryKey
    ? sortedCategories?.findIndex(
        (category) => category && category?.key === categoryKey,
      ) + 1
    : sortedCategories.length;
  _.forEach(categoriesToAdd, (categoryToAdd) => {
    processCategoryToAdd({
      categoryToAdd,
      categories,
      sortedCategories,
      parentItemLabel,
      parentItemRecursiveKey,
      isMultiple,
      linkBetweenOptionsAndSubOptions,
      categoryToAddPosition,
      newSubcategories,
    });
  });
  return {
    categories,
    sortedCategories: sortedCategories.concat(newSubcategories),
    linkBetweenOptionsAndSubOptions,
  };
};
const processCategoryToAdd = ({
  categoryToAdd,
  categories,
  sortedCategories,
  parentItemLabel,
  parentItemRecursiveKey,
  isMultiple,
  linkBetweenOptionsAndSubOptions,
  categoryToAddPosition,
  newSubcategories,
}) => {
  const categoryKey = categoryToAdd?.split(ITEM_KEY_COUNTER_SEPARATOR)[0];
  const shopCategory = categories?.[categoryKey];
  if (!shopCategory) {
    return;
  }
  const modifiedShopCategory = createModifiedShopCategory({
    shopCategory,
    categoryToAdd,
    parentItemLabel,
    parentItemRecursiveKey,
    isMultiple,
  });
  categories[modifiedShopCategory.key] = modifiedShopCategory;
  updateSortedCategories({
    categories,
    sortedCategories,
    modifiedShopCategory,
    parentCategoryKey: getCategoryFromItemRecursiveKey(parentItemRecursiveKey),
    linkBetweenOptionsAndSubOptions,
    categoryToAddPosition,
    newSubcategories,
  });
};
const getCategoryFromItemRecursiveKey = (itemRecursiveKey) => {
  if (!itemRecursiveKey?.includes(ITEM_KEY_CATEGORY_SEPARATOR)) {
    return null;
  }
  const lastSeparatorIndex = itemRecursiveKey.lastIndexOf(
    ITEM_KEY_CATEGORY_SEPARATOR,
  );
  return itemRecursiveKey.substring(0, lastSeparatorIndex);
};

export const isUniqueOption = (option) =>
  option?.min === 1 && option?.max === 1;
const updateSortedCategories = ({
  categories,
  sortedCategories,
  modifiedShopCategory,
  parentCategoryKey,
  linkBetweenOptionsAndSubOptions,
  categoryToAddPosition,
  newSubcategories,
}) => {
  if (parentCategoryKey) {
    const parentCategoryIndex = sortedCategories.findIndex(
      (category) => category && category?.key === parentCategoryKey,
    );
    if (parentCategoryIndex !== NOT_FOUND_INDEX) {
      linkBetweenOptionsAndSubOptions.set(parentCategoryKey, [
        ...new Set([
          ...(linkBetweenOptionsAndSubOptions.get(parentCategoryKey) || []),
          modifiedShopCategory.key,
        ]),
      ]);
      const lastIndex = findLastIndexOfCommonSubOptions(
        categories[parentCategoryKey],
        modifiedShopCategory.key,
        parentCategoryIndex,
        linkBetweenOptionsAndSubOptions,
        parentCategoryKey,
        sortedCategories,
      );
      sortedCategories.splice(lastIndex + 1, 0, modifiedShopCategory);
    } else {
      newSubcategories.push(modifiedShopCategory);
    }
  } else if (categoryToAddPosition) {
    sortedCategories.splice(categoryToAddPosition, 0, modifiedShopCategory);
  } else {
    sortedCategories.push(modifiedShopCategory);
  }
};

const getItemOriginalKeyFromSubItemRecursiveKey = (itemRecursiveKey) => {
  if (!itemRecursiveKey?.includes(ITEM_KEY_CATEGORY_SEPARATOR)) {
    return itemRecursiveKey;
  }
  const splitItemFullKey = itemRecursiveKey.split(ITEM_KEY_CATEGORY_SEPARATOR);
  return splitItemFullKey?.[splitItemFullKey?.length - 2]?.split(
    ITEM_KEY_COUNTER_SEPARATOR,
  )?.[0];
};
const getOrderedSubOptions = (subOptions, parentCategory) =>
  subOptions?.sort((subOpt1, subOpt2) => {
    const itemKey1 = getItemOriginalKeyFromSubItemRecursiveKey(subOpt1);
    const itemKey2 = getItemOriginalKeyFromSubItemRecursiveKey(subOpt2);
    const positionSubOpt1 = parentCategory?.items?.[itemKey1]?.position || 0;
    const positionSubOpt2 = parentCategory?.items?.[itemKey2]?.position || 0;
    return positionSubOpt1 - positionSubOpt2;
  });

const findLastIndexOfCommonSubOptions = (
  parentCategory,
  subOptionKey,
  parentCategoryIndex,
  linkBetweenOptionsAndSubOptions,
  parentCategoryKey,
  sortedCategories,
) => {
  const subOptions = linkBetweenOptionsAndSubOptions?.get(parentCategoryKey);
  if (!subOptions || subOptions?.length <= 1) {
    return parentCategoryIndex;
  }
  const orderedSubOptions = getOrderedSubOptions(subOptions, parentCategory);
  const subOptionPosition = orderedSubOptions.indexOf(subOptionKey);
  if (subOptionPosition === NOT_FOUND_INDEX) {
    return parentCategoryIndex;
  }
  const previousSubOptionKey = orderedSubOptions[subOptionPosition - 1];
  if (!previousSubOptionKey) {
    return parentCategoryIndex;
  }
  const lastPositionOfDepedenciesOfThePreviousSubOption = _.findLastIndex(
    sortedCategories,
    (category: any) => {
      return (
        category?.key === previousSubOptionKey ||
        category?.key.startsWith(
          previousSubOptionKey + ITEM_KEY_CATEGORY_SEPARATOR,
        )
      );
    },
  );

  return lastPositionOfDepedenciesOfThePreviousSubOption !== NOT_FOUND_INDEX
    ? lastPositionOfDepedenciesOfThePreviousSubOption
    : parentCategoryIndex;
};

const createModifiedShopCategory = ({
  shopCategory,
  categoryToAdd,
  parentItemLabel,
  parentItemRecursiveKey,
  isMultiple,
}) => {
  const modifiedShopCategory = _.cloneDeep(shopCategory);
  modifiedShopCategory.originalName =
    shopCategory?.originalName || shopCategory.name;
  if (parentItemRecursiveKey && parentItemLabel) {
    modifiedShopCategory.name = formatCategoryName({
      shopCategory,
      parentItemLabel,
      parentItemRecursiveKey,
      isMultiple,
    });
    modifiedShopCategory.key = generateSubcategoryKey(
      parentItemRecursiveKey,
      categoryToAdd,
    );
    modifiedShopCategory.id = shopCategory.key;
  } else {
    modifiedShopCategory.key = categoryToAdd;
    modifiedShopCategory.id = shopCategory.key;
  }
  return modifiedShopCategory;
};

const formatCategoryName = ({
  shopCategory,
  parentItemLabel,
  parentItemRecursiveKey,
  isMultiple,
}) => {
  const counter = getCounterFromItemRecursiveKey(parentItemRecursiveKey);
  const categoryCounterName = counter && isMultiple ? ` N°${counter}` : "";
  const parentItemNamePrefix = `${parentItemLabel}${categoryCounterName} - `;
  return shopCategory.name.includes(parentItemNamePrefix)
    ? shopCategory.name
    : `${parentItemNamePrefix}${
        shopCategory.originalName || shopCategory.name
      }`;
};

export const generateSubcategoryKey = (
  parentItemRecursiveKey,
  subcategoryKey,
) => `${parentItemRecursiveKey}${ITEM_KEY_CATEGORY_SEPARATOR}${subcategoryKey}`;
const getCounterFromItemRecursiveKey = (itemRecursiveKey) => {
  if (!itemRecursiveKey?.includes(ITEM_KEY_COUNTER_SEPARATOR)) {
    return null;
  }
  const cutKey = itemRecursiveKey?.split(ITEM_KEY_COUNTER_SEPARATOR);
  return cutKey?.[cutKey?.length - 1];
};

export const optionHasNotEnoughStock = (
  productItems,
  pendingOrder,
  item,
  nbProduct,
) => {
  let notEnoughStock = false;
  let stockRemainingOption: string | boolean = false;
  const { productKey } = item;
  if (productKey) {
    const product = getOptionAssociatedProduct(item);
    if (product) {
      stockRemainingOption = getStockRemainingOption(
        productItems,
        pendingOrder,
        item,
        nbProduct,
      );
      notEnoughStock = isProductDisabled(product);
    }
  }
  return notEnoughStock || parseInt(stockRemainingOption as string, 10) <= 0;
};

export const generateItemRecursiveKey = (
  item: any,
  counter: any = null,
): string => {
  const itemInitialKey = `${item.categoryKey}${ITEM_KEY_CATEGORY_SEPARATOR}${item.key}`;
  return counter !== undefined && parseInt(counter, 10) >= 0
    ? `${itemInitialKey}${ITEM_KEY_COUNTER_SEPARATOR}${counter}`
    : itemInitialKey;
};

export const getNbInCartOfProduct = (
  key,
  pendingOrder,
  optionProductKey = null,
) => {
  let nbInCart = 0;
  _.map(pendingOrder?.commande, (productInCart) => {
    const { nb } = productInCart;
    if (
      key === productInCart.key ||
      (optionProductKey && optionProductKey === productInCart.key)
    ) {
      nbInCart += nb;
    } else {
      _.map(productInCart.items, (itemInCart) => {
        if (itemInCart) {
          _.map(itemInCart.options, (optionInCart) => {
            if (key === optionInCart.key || key === optionInCart.productKey) {
              const optionProductNb = optionInCart.productNb || 1;
              const optionProduct = getOptionAssociatedProduct(optionInCart);
              if (optionProduct) {
                nbInCart += nb * optionProductNb;
              }
            }
          });
        }
      });
    }
  });
  return nbInCart;
};

export const getStockRemainingOption = (
  productItems,
  pendingOrder,
  option,
  nbProduct,
) => {
  let stockRemainingOption = null;
  const stockOption = getStockOption(option);
  if (parseInt(stockOption, 10) >= 0) {
    const { key, productKey } = option;
    const nbOption = getCurrentNbOption(productItems, key);
    const nbInCart = getNbInCartOfProduct(key, pendingOrder, productKey);
    stockRemainingOption = getStockRemaining(
      stockOption,
      nbInCart,
      nbProduct * nbOption,
    );
    if (
      stockRemainingOption > 0 &&
      getStockRemaining(stockOption, nbInCart, nbProduct * (nbOption + 1)) < 0
    ) {
      stockRemainingOption = 0;
    }
  }
  return stockRemainingOption;
};

export const getStockOption = (option: any): any => {
  let stockOption = null;
  const product = getOptionAssociatedProduct(option);
  if (product && parseInt(product.stock, 10) >= 0) {
    stockOption = product.stock;
  }
  return stockOption;
};

export const getMinimumStockRemaining = (
  productItems,
  product,
  pendingOrder,
  nbProduct,
) => {
  let result = {};
  const productStock = product.stock;
  let minimumStock: number | false = false;
  _.map(productItems, (category) => {
    if (category) {
      _.map(category.options, (option) => {
        const product = getOptionAssociatedProduct(option);
        if (product) {
          const { key, productKey } = option;
          const optionStock = product.stock;
          const nbOption = getCurrentNbOption(productItems, option.key);
          const nbInCart = getNbInCartOfProduct(key, pendingOrder, productKey);
          let stockRemaining = getStockRemaining(
            optionStock,
            nbInCart,
            nbProduct * nbOption,
          );

          if (
            stockRemaining > 0 &&
            getStockRemaining(
              optionStock,
              nbInCart,
              (nbProduct + 1) * nbOption,
            ) < 0
          ) {
            stockRemaining = 0;
          }
          if (
            option.key &&
            parseInt(stockRemaining as any, 10) >= 0 &&
            (minimumStock === false || stockRemaining < minimumStock)
          ) {
            minimumStock = stockRemaining;
            result = {
              stock: optionStock,
              name: option.name,
              key: option.key,
              stockRemaining,
            };
          }
        }
      });
    }
  });
  const nbInCart = getNbInCartOfProduct(product.key, pendingOrder);
  const stockRemaining = getStockRemaining(productStock, nbInCart, nbProduct);
  if (
    product.key &&
    parseInt(stockRemaining as any, 10) >= 0 &&
    (minimumStock === false || stockRemaining < minimumStock)
  ) {
    result = {
      stock: productStock,
      name: product.name,
      key: product.key,
      stockRemaining,
    };
  }
  return result;
};

export const generateOptionChoiceMessage = (category) => {
  let choiceMessage = category?.min ? "* Champ Obligatoire" : "";
  if (!isUniqueOption(category)) {
    choiceMessage += category?.min ? " - " : "";
    if (category?.min && category?.min < category?.max) {
      choiceMessage += `Entre ${category.min} et ${category.max} choix`;
    } else if (category?.min && category?.min === category?.max) {
      choiceMessage += `Choisissez ${category.max} choix`;
    } else if (category?.min && !category?.max) {
      choiceMessage += `Choisissez au moins ${category.min} choix`;
    } else if (category?.max > 1) {
      choiceMessage += `Choisissez jusqu'à ${category.max}`;
    }
  }
  return choiceMessage;
};

type GetOptionDataResult = {
  image: any;
  description: any;
};

export const getOptionData = (item: any): GetOptionDataResult => {
  const { productKey } = item;
  let result = {
    image: undefined,
    description: undefined,
  };
  if (productKey) {
    const product = getOptionAssociatedProduct(item);
    if (product) {
      const { image, imageCompressed, description } = product;
      result = {
        image: isStringNotNull(imageCompressed) ? imageCompressed : image,
        description,
      };
    }
  }
  return result;
};

export const isCheckedOrSelected = (
  productItems: any,
  index: number,
  item: any,
): boolean => {
  return !!_.find(
    productItems?.[index]?.options,
    (option) =>
      option?.itemRecursiveKey &&
      option.itemRecursiveKey === generateItemRecursiveKey(item, undefined),
  );
};

const processSubItemsToRemove = (
  subItemsToRemove,
  newProductItems,
  newItemsCounter,
  categories,
  sortedCategories,
  itemKeysToRemove,
  shouldUpdateItemsCounter,
  linkBetweenOptionsAndSubOptions,
) => {
  for (const item of subItemsToRemove) {
    const result = determineImpactedItemsAndRespectiveCounter(
      item,
      newProductItems,
      newItemsCounter,
      item.itemRecursiveKey,
      linkBetweenOptionsAndSubOptions,
      categories,
      sortedCategories,
      itemKeysToRemove,
      shouldUpdateItemsCounter,
      true,
    );
    shouldUpdateItemsCounter =
      result?.updatedShouldUpdateItemsCounter || shouldUpdateItemsCounter;
  }
  return shouldUpdateItemsCounter;
};
const generateCategoriesToRemove = (removedItem, itemRecursiveKey) =>
  !removedItem?.subcategories?.length
    ? []
    : removedItem.subcategories
        .split(CATEGORY_SEPARATOR)
        .map((subCategory) =>
          generateSubcategoryKey(
            itemRecursiveKey ||
              removedItem?.itemRecursiveKey ||
              removedItem.key,
            subCategory,
          ),
        );

const findSubItemsToRemove = (newProductItems, categoriesToRemove) =>
  !categoriesToRemove?.length
    ? []
    : categoriesToRemove.flatMap((categoryKey) =>
        Object.values(newProductItems)
          .filter(
            (item: any) => categoryKey && item?.categoryKey === categoryKey,
          )
          .flatMap((item: any) =>
            item?.options ? Object.values(item.options) : null,
          )
          .filter((itemOption) => !!itemOption),
      );

const handleRemovedItemOptions = (
  itemPositionKey,
  itemKeysToRemove,
  removedOptionRecursiveKey,
  eraseItemCounter,
  item,
  newItemsCounter,
  shouldUpdateItemsCounter,
  linkBetweenOptionsAndSubOptions,
  parentCategoryKey,
) => {
  if (item?.options) {
    _.forEach(item.options, (option, optionGeneratedId) => {
      if (
        removedOptionRecursiveKey &&
        option?.itemRecursiveKey === removedOptionRecursiveKey
      ) {
        itemKeysToRemove.set(itemPositionKey, [
          ...(itemKeysToRemove.get(itemPositionKey) || []),
          optionGeneratedId,
        ]);
        if (linkBetweenOptionsAndSubOptions?.has(parentCategoryKey)) {
          const subOptionFullKeys = option?.subcategories
            ?.split(CATEGORY_SEPARATOR)
            ?.map((subcategoryKey) =>
              generateSubcategoryKey(option.itemRecursiveKey, subcategoryKey),
            );
          linkBetweenOptionsAndSubOptions.set(
            parentCategoryKey,
            linkBetweenOptionsAndSubOptions
              .get(parentCategoryKey)
              .filter((subOp) => !subOptionFullKeys?.includes(subOp)),
          );
        }
        const counterOptionKey = generateCounterOptionKey(
          item?.categoryKey,
          option.key,
        );
        if (
          eraseItemCounter &&
          newItemsCounter[counterOptionKey] !== undefined
        ) {
          delete newItemsCounter[counterOptionKey];
          shouldUpdateItemsCounter = true;
        }
      }
    });
  }
  return shouldUpdateItemsCounter;
};
export const removeCategories = (
  categories,
  sortedCategories,
  categoriesToRemove,
) => {
  sortedCategories.forEach((category, index) => {
    if (!category) {
      return;
    }
    if (categoriesToRemove.includes(category?.key)) {
      sortedCategories[index] = null;
      delete categories[category?.key];
    }
  });
};
const determineImpactedItemsAndRespectiveCounter = (
  removedItem,
  newProductItems,
  newItemsCounter,
  itemRecursiveKey,
  linkBetweenOptionsAndSubOptions,
  categories,
  sortedCategories,
  itemKeysToRemove = new Map(),
  shouldUpdateItemsCounter = false,
  eraseItemCounter = false,
) => {
  const categoriesToRemove = generateCategoriesToRemove(
    removedItem,
    itemRecursiveKey,
  );
  const subItemsToRemove = findSubItemsToRemove(
    newProductItems,
    categoriesToRemove,
  );
  const parentCategoryKey = getCategoryFromItemRecursiveKey(itemRecursiveKey);
  for (const [key, item] of Object.entries(newProductItems) as [
    string,
    any,
  ][]) {
    if (item?.categoryKey && item?.categoryKey === removedItem?.categoryKey) {
      shouldUpdateItemsCounter = handleRemovedItemOptions(
        key,
        itemKeysToRemove,
        itemRecursiveKey,
        eraseItemCounter,
        item,
        newItemsCounter,
        shouldUpdateItemsCounter,
        linkBetweenOptionsAndSubOptions,
        parentCategoryKey,
      );
      break;
    }
  }
  if (categoriesToRemove.length) {
    removeCategories(categories, sortedCategories, categoriesToRemove);
  }
  const updatedShouldUpdateItemsCounter = processSubItemsToRemove(
    subItemsToRemove,
    newProductItems,
    newItemsCounter,
    categories,
    sortedCategories,
    itemKeysToRemove,
    shouldUpdateItemsCounter,
    linkBetweenOptionsAndSubOptions,
  );
  return { itemKeysToRemove, updatedShouldUpdateItemsCounter };
};
export const handleRemovedItemSubCategories = (
  removedItem,
  newProductItems,
  newItemsCounter,
  itemRecursiveKey,
  eraseItemCounter,
  linkBetweenOptionsAndSubOptions = new Map(),
  categories,
  sortedCategories,
) => {
  const {
    itemKeysToRemove,
    updatedShouldUpdateItemsCounter: shouldUpdateItemsCounter,
  } = determineImpactedItemsAndRespectiveCounter(
    removedItem,
    newProductItems,
    newItemsCounter,
    itemRecursiveKey,
    linkBetweenOptionsAndSubOptions,
    categories,
    sortedCategories,
    new Map(),
    false,
    eraseItemCounter,
  );
  itemKeysToRemove?.forEach((optionKeys, key) => {
    optionKeys?.forEach((optionKey) => {
      delete newProductItems[key]?.options?.[optionKey];
    });
    if (!_.keys(newProductItems[key]?.options)?.length) {
      delete newProductItems[key];
    }
  });
  return shouldUpdateItemsCounter;
};

export const removeItem = (
  key,
  item,
  setState,
  productItems,
  state,
  counter = null,
) => {
  const {
    itemsCounter: updatedItemsCounter,
    linkBetweenOptionsAndSubOptions,
    categories,
    sortedCategories,
  } = _.cloneDeep(state);
  const newProductItems = _.cloneDeep(productItems);
  const itemRecursiveKey = generateItemRecursiveKey(item, counter);
  const newProductItem = newProductItems[key];
  let updateItemsCounter = handleRemovedItemSubCategories(
    item,
    newProductItems,
    updatedItemsCounter,
    itemRecursiveKey,
    false,
    linkBetweenOptionsAndSubOptions,
    categories,
    sortedCategories,
  );
  if (counter) {
    const optionKey = generateCounterOptionKey(
      newProductItem?.categoryKey,
      item.key,
    );
    counter -= 1;
    updatedItemsCounter[optionKey] = counter;
    updateItemsCounter = true;
  }
  const itemGeneratedId = _.findKey(
    newProductItem.options,
    (option) =>
      itemRecursiveKey && option?.itemRecursiveKey === itemRecursiveKey,
  );
  if (itemGeneratedId) {
    delete newProductItem?.options[itemGeneratedId];
  }
  if (newProductItem?.options && _.keys(newProductItem?.options).length === 0) {
    delete newProductItems[key];
  } else {
    const optionFree = categories[newProductItem.categoryId]?.optionFree;
    if (optionFree) {
      const optionKeys = Object.keys(newProductItem.options ?? {});
      for (
        let index = 0;
        index < optionFree && index < optionKeys.length;
        index++
      ) {
        const optionKey = optionKeys[index];

        if (newProductItem.options?.[optionKey]) {
          newProductItem.options[optionKey].price = 0;
          newProductItem.options[optionKey].isFree = true;
        }
      }
    }
    newProductItems[key] = newProductItem;
  }
  setState({
    productItems: sortProductItemsAccordingToSortedCategories(
      newProductItems,
      sortedCategories,
    ),
    linkBetweenOptionsAndSubOptions,
    categories,
    sortedCategories,
    ...(updateItemsCounter ? { itemsCounter: updatedItemsCounter } : {}),
  });
};

export const addItem = (
  index,
  category,
  item,
  setState,
  productItems,
  state,
  counter = null,
  itemsCounter = null,
) => {
  let newProductItems = _.cloneDeep(productItems);
  let {
    categories: updatedCategories,
    sortedCategories: updatedSortedCategories,
    linkBetweenOptionsAndSubOptions: updatedLinkBetweenOptionsAndSubOptions,
  } = _.cloneDeep(state);
  const itemRecursiveKey = generateItemRecursiveKey(item, counter);
  if (item?.subcategories?.length) {
    const subCategoryUpdateResult = updateSubCategories(
      productItems,
      updatedCategories,
      updatedSortedCategories,
      updatedLinkBetweenOptionsAndSubOptions,
      category.key,
      item,
      itemRecursiveKey,
      category.multiple,
    );
    ({
      updatedProductItems: newProductItems,
      categories: updatedCategories,
      sortedCategories: updatedSortedCategories,
      linkBetweenOptionsAndSubOptions: updatedLinkBetweenOptionsAndSubOptions,
    } = subCategoryUpdateResult);
  }
  newProductItems[index] = generateProductItem(
    category,
    index,
    productItems,
    itemRecursiveKey,
    item,
  );
  setState({
    productItems: sortProductItemsAccordingToSortedCategories(
      newProductItems,
      updatedSortedCategories,
    ),
    categories: updatedCategories,
    sortedCategories: updatedSortedCategories,
    linkBetweenOptionsAndSubOptions: updatedLinkBetweenOptionsAndSubOptions,
    ...(counter ? { itemsCounter } : {}),
  });
};

export const handleCounterClickService = ({
  increaseDisabled,
  item,
  category,
  key,
  isAdd,
  itemsCounter,
  productItems,
  state,
  setState,
}) => {
  const optionKey = generateCounterOptionKey(category.key, item.key);
  let counter = itemsCounter[optionKey] || 0;

  if (isAdd) {
    if (increaseDisabled) return;
    counter += 1;
    itemsCounter[optionKey] = counter;
    addItem(
      key,
      category,
      item,
      setState,
      productItems,
      state,
      counter,
      itemsCounter,
    );
  } else removeItem(key, item, setState, productItems, state, counter);
};

export const handleRadioButtonPress = ({
  index,
  category,
  item,
  isSelected,
  state,
  productItems,
  itemsCounter,
  setState,
}) => {
  if (isSelected) return;

  const newCategories = structuredClone(state.categories);
  const newSortedCategories = structuredClone(state.sortedCategories);
  const newLink = structuredClone(state.linkBetweenOptionsAndSubOptions);
  const workingProductItems = structuredClone(productItems);

  const itemRecursiveKey = generateItemRecursiveKey(item);

  const {
    updatedProductItems,
    productItemToRemove,
    categories,
    sortedCategories,
    linkBetweenOptionsAndSubOptions,
  } = updateSubCategories(
    workingProductItems,
    newCategories,
    newSortedCategories,
    newLink,
    category.key,
    item,
    itemRecursiveKey,
    false,
  );

  if (productItemToRemove?.options) {
    for (const opt of Object.values(productItemToRemove.options) as any[]) {
      handleRemovedItemSubCategories(
        opt,
        updatedProductItems,
        itemsCounter,
        opt?.itemRecursiveKey,
        true,
        linkBetweenOptionsAndSubOptions,
        categories,
        sortedCategories,
      );
    }
  }

  updatedProductItems[index] = generateProductItem(
    category,
    index,
    updatedProductItems,
    itemRecursiveKey,
    item,
  );

  setState({
    productItems: sortProductItemsAccordingToSortedCategories(
      updatedProductItems,
      sortedCategories,
    ),
    itemsCounter,
    categories,
    sortedCategories,
    linkBetweenOptionsAndSubOptions,
  });
};
export const handleCheckBoxPressService = ({
  key,
  category,
  item,
  checked,
  productItems,
  state,
  setState,
}) => {
  if (checked) {
    removeItem(key, item, setState, productItems, state);
  } else {
    addItem(key, category, item, setState, productItems, state);
  }
};
export const getSelectedCount = (
  productItems,
  category,
  itemsCounter,
  index,
) => {
  const productItem = productItems?.[index];
  const isMultiple = !!category.multiple && category.max !== 1;
  const options = productItem?.options ?? [];

  const selectedCount = isMultiple
    ? _.size(options)
    : _.filter(options, (opt) => isCheckedOrSelected(productItems, index, opt))
        .length;

  return selectedCount;
};

export const getMissingRequiredCategory = (
  sortedCategories: any[],
  productItems: any[],
  itemsCounter: any,
): string | null => {
  const missingCategory = _.find(sortedCategories, (category, index) => {
    if (!category?.min) return false;

    const min = category.min ?? 0;
    return getSelectedCount(productItems, category, itemsCounter, index) < min;
  });
  return missingCategory?.key ?? null;
};

export const scrollToCategory = (
  categoryId: string | undefined,
  categoryRefs,
  scrollContainerRef,
) => {
  if (
    !categoryId ||
    !categoryRefs.current[categoryId] ||
    !scrollContainerRef.current
  )
    return;

  const category = categoryRefs.current[categoryId];
  const container = scrollContainerRef.current;

  const SCROLL_OFFSET = 10;
  const top =
    category!.offsetTop -
    container.offsetTop -
    SCROLL_OFFSET -
    STICKY_HEADER_HEIGHT -
    SCROLL_OFFSET;

  container.scrollTo({ top, behavior: "smooth" });
};

export const computeStickyHeader = (
  container: HTMLDivElement,
  titleEl: HTMLElement | null,
  missingCategoryId: string | null,
  categoryRefs: Record<string, HTMLDivElement | null>,
  currentlySticky: boolean,
  lastThreshold: number,
  hasImage: boolean,
) => {
  const scroll = container.scrollTop;

  let threshold = lastThreshold;
  if (titleEl) {
    const measured =
      titleEl.offsetTop + titleEl.offsetHeight - container.offsetTop;
    if (measured > 0) {
      threshold = measured;
    }
  }
  if (hasImage && threshold < STICKY_HEADER_HEIGHT) {
    threshold = STICKY_HEADER_HEIGHT;
  }

  const HYSTERESIS = STICKY_HEADER_HEIGHT;
  let shouldShow = currentlySticky
    ? scroll > threshold - HYSTERESIS
    : scroll > threshold;

  if (missingCategoryId) {
    const missingCategory = categoryRefs[missingCategoryId];

    if (missingCategory) {
      const missingTop = missingCategory.offsetTop;

      if (scroll < missingTop && missingTop <= container.scrollHeight) {
        shouldShow = true;
      }
    }
  }

  return {
    shouldShow,
    scroll,
    threshold,
  };
};

export const getSortedCategoryItems = (
  category: any,
  productItems: any[],
  index: number,
) => {
  const optionsArray = _.values(productItems[index]?.options);
  const freeItems: string[] = [];
  optionsArray.forEach((elm, i) => {
    if (category.optionFree && i < category.optionFree) freeItems.push(elm.key);
  });

  const items = _.sortBy(
    _.map(category.items, (option) => {
      let isFree = option.isFree;
      if (category.optionFree) {
        const isFreeItem = category.multiple
          ? freeItems.includes(option?.key) &&
            freeItems.length < category.optionFree
          : freeItems.includes(option?.key);
        isFree = isFreeItem || _.size(optionsArray) < category.optionFree;
      }
      return {
        ...option,
        nb: option.nb ?? 1,
        label: option.name,
        categoryKey: category.key,
        value: option.position,
        isFree,
      };
    }),
    "value",
  );
  return items;
};

export function getOptionProps({
  item,
  index,
  productItems,
  pendingOrder,
  nbProduct,
  category,
  missingCategoryId,
  selectedCount,
  min,
  isMultiple,
  uniqueOption,
}) {
  const { image, description } = getOptionData(item);
  const checkedOrSelected = isCheckedOrSelected(productItems, index, item);
  const notEnoughStock = optionHasNotEnoughStock(
    productItems,
    pendingOrder,
    item,
    nbProduct,
  );
  const productItem = productItems[index];
  const concernedProductItem = productItem?.categoryKey === category.key;

  const currentItemSelected = _.filter(
    productItem?.options,
    (opt) => opt.key === item.key,
  );
  const multipleMaxItemSelected =
    concernedProductItem && category?.multipleMax
      ? _.size(currentItemSelected) >= category?.multipleMax
      : false;
  const totalMaxItemsSelected =
    concernedProductItem && _.size(productItem?.options ?? {}) >= category?.max;
  const maxAllowedItemsReached =
    totalMaxItemsSelected || multipleMaxItemSelected;

  const checkBoxDisabled =
    (totalMaxItemsSelected || notEnoughStock) && !checkedOrSelected;
  const increaseDisabled =
    totalMaxItemsSelected || notEnoughStock || multipleMaxItemSelected;
  const uniqueOptionDisabled =
    notEnoughStock ||
    (maxAllowedItemsReached && isMultiple) ||
    (!uniqueOption && checkBoxDisabled);

  return {
    key: item.id,
    reverse: true,
    label: item.label,
    price: item.isFree ? undefined : item.price,
    imageSize: 40,
    withoutDivider: true,
    isError: missingCategoryId === category.key && selectedCount < min,
    description,
    image,
    checkedOrSelected,
    notEnoughStock,
    checkBoxDisabled,
    increaseDisabled,
    addDisabled: increaseDisabled,
    uniqueOptionDisabled,
  };
}

export const getStockRemainingMessage = (stockRemaining, productName) => {
  if (stockRemaining > 0 && stockRemaining <= STOCK_ALMOST_EMPTY) {
    return {
      text: `Plus que ${stockRemaining} ${productName} en stock -`,
      severity: "warning",
    };
  }
  if (stockRemaining <= 0) {
    return {
      text: `Plus de ${productName} en stock -`,
      severity: "error",
    };
  }
};
